import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.sort";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:\\RiderProjects\\pdcweb\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { SortField } from "../../utils/helper";
import { MotorParaSet } from "../../api/MotorMonitoringDevice";
import { provinceAndCityData, CodeToText } from 'element-china-area-data';
var that;
export default {
  name: 'motor',
  data: function data() {
    return {
      tableHeight: window.innerHeight * 0.6,
      headTitle: '',
      viewVisible: false,
      isadd: false,
      motor: {},
      paramSet: {},
      editVisible: false,
      paramVisible: false,
      motors: [],
      pageCount: 1,
      multipleSelection: [],
      delList: [],
      loading: false,
      query: {
        Field1: '',
        Field2: '',
        PageIndex: 1,
        PageSize: 15
      },
      volidArr: [],
      FrequencyArr: [],
      rules: {
        code: [{
          required: true,
          message: '请输入编号',
          trigger: 'blur'
        }, {
          min: 1,
          max: 15,
          message: '长度在 1 到 15 个字符',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }],
        mineName: [{
          required: true,
          message: '请输入煤矿名称',
          trigger: 'blur'
        }],
        frequencyId: [{
          required: true,
          message: '请选择计划',
          trigger: 'blur'
        }]
      },
      AgreementVersion: [],
      equimentType: [],
      pRules: {
        zerov: [{
          required: true,
          message: '请输入零点',
          trigger: 'blur'
        }],
        kv1: [{
          required: true,
          message: '请输入校验值',
          trigger: 'blur'
        }],
        speedcompyv: [{
          required: true,
          message: '请输入速度系数',
          trigger: 'blur'
        }]
      },
      options: provinceAndCityData,
      selectedOptions: []
    };
  },
  filters: {
    motortypeFormat: function motortypeFormat(UserType) {
      var usertypeName = '';
      var list = that.equimentType.filter(function (x) {
        return x.value == UserType;
      });

      if (list.length > 0) {
        usertypeName = list[0].name;
      }

      return usertypeName;
    },
    agreementTypeFormat: function agreementTypeFormat(UserType) {
      var usertypeName = '';
      var list = that.AgreementVersion.filter(function (x) {
        return x.id == UserType;
      });

      if (list.length > 0) {
        usertypeName = list[0].name;
      }

      return usertypeName;
    }
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var res, search, resequ;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$zybhttp.get('Motor/GetAgreementVersion', {});

            case 2:
              res = _context.sent;

              if (res.data.status == 0) {
                this.AgreementVersion = res.data.data;
              }

              search = {
                Field2: 'equimentType',
                Field4: '1'
              };
              _context.next = 7;
              return this.$zybhttp.post('DataCode/GetStructList', search);

            case 7:
              resequ = _context.sent;

              if (resequ.data.status == 0) {
                this.equimentType = resequ.data.data.list;
              }

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  beforeCreate: function beforeCreate() {
    that = this;
  },
  mounted: function mounted() {
    this.getData();
  },
  methods: {
    saveEdit: function saveEdit() {
      var _this = this;

      this.$refs['motor'].validate(function (valid) {
        if (valid) {
          _this.motor.isUse = _this.motor.isUse ? '1' : '0';
          var loc = [];

          for (var i = 0; i < _this.selectedOptions.length; i++) {
            loc.push(CodeToText[_this.selectedOptions[i]]);
          }

          _this.motor.provincecityCode = _this.selectedOptions.join('/');
          _this.motor.provinceCity = loc.join('/');
          console.log(_this.motor);

          if (_this.isadd) {
            _this.$zybhttp.post('Motor/MotorAdd', _this.motor).then(function (res) {
              if (res.data.status == 0) {
                _this.$notify.success(res.data.msg);

                _this.getData();

                _this.editVisible = false;
                _this.motor = {};
              } else {
                _this.$notify.error(res.data.msg);
              }
            }).catch(function (err) {
              return _this.$notify.error('网络异常！添加失败');
            });
          } else {
            _this.$zybhttp.post('Motor/MotorUpdate', _this.motor).then(function (res) {
              if (res.data.status == 0) {
                _this.$notify.success(res.data.msg);

                _this.getData();

                _this.editVisible = false;
              } else {
                _this.$notify.error(res.data.msg);
              }
            }).catch(function (err) {
              return _this.$notify.error('网络异常！修改失败');
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    saveParam: function saveParam() {
      var _this2 = this;

      this.$refs['paramSet'].validate(function (valid) {
        if (valid) {
          console.log(_this2.paramSet);

          _this2.$zybhttp.post('Motor/MotorParaSet', _this2.paramSet).then(function (res) {
            if (res.data.status == 0) {
              _this2.$notify.success(res.data.msg);

              _this2.getData();

              _this2.paramVisible = false;
              _this2.paramSet = {};
            } else {
              _this2.$notify.error(res.data.msg);
            }
          }).catch(function (err) {
            return _this2.$notify.error('网络异常！添加失败');
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    clsOpt: function clsOpt() {
      this.getData();
    },
    getData: function getData() {
      var _this3 = this;

      this.$zybhttp.post('Motor/GetList', this.query).then(function (res) {
        console.log(res.data.status);

        if (res.data.status == 0) {
          res = res.data;
          var d = res.data.list;
          var newdata = d.sort(SortField('Id', 'desc'));
          newdata = newdata.map(function (x) {
            console.log(x);
            x.isUseFt = x.isUse == '1';
            x.isUseMonitor = x.isShowMonitor == '1';
            return x;
          }, []);
          _this3.motors = newdata;
          _this3.pageCount = res.data.total || 0;
        } else {
          _this3.$notify.error(res.message);
        }
      }).catch(function (err) {
        return _this3.$notify.error('网络异常！获取列表失败！');
      });
    },
    getFrequency: function getFrequency() {
      var _this4 = this;

      var serach = {};
      this.$zybhttp.post('Frequency/GetList', serach).then(function (res) {
        if (res.data.status == 0) {
          var d = res.data.data.list;
          _this4.FrequencyArr = d.sort(SortField('id', 'asc'));
        } else {
          _this4.$notify.error(res.message);
        }
      }).catch(function (err) {
        return _this4.$notify.error('网络异常！获取列表失败！');
      });
    },
    getAxiso: function getAxiso() {
      this.$zybhttp.get('Motor/MotorDel?ids=1').then(function (res) {}).catch(function (err) {
        return console.log(err, '网络异常！获取列表失败！');
      });
    },
    handleEdit: function handleEdit(id, row) {
      this.getFrequency();
      this.motor = JSON.parse(JSON.stringify(row)); // row;

      this.motor.id = id;
      this.editVisible = true;
      this.motor.isUse = this.motor.isUse == 1;
      this.selectedOptions = this.motor.provinceCityCode == null ? [] : this.motor.provinceCityCode.split('/');
      this.isadd = false;
      this.headTitle = '修改设备信息';
    },
    dbSelected: function dbSelected(row) {
      this.getFrequency();
      this.motor = row;
      this.motor.id = row.id;
      this.editVisible = true;
      this.motor.isUse = this.motor.isUse == 1;
      this.selectedOptions = this.motor.provinceCityCode == null ? [] : this.motor.provinceCityCode.split('/');
      this.isadd = false;
      this.headTitle = '修改设备信息';
    },
    handleShow: function handleShow(index, row) {
      this.motor = row;
      this.viewVisible = true;
    },
    handleAdd: function handleAdd() {
      this.getFrequency();
      var ms_userInfo = localStorage.getItem('ms_userInfo');
      var userinfo = JSON.parse(ms_userInfo);
      this.motor = {};
      this.isadd = true;
      var date = new Date();
      this.motor.createUserId = userinfo.loginId;
      this.motor.modifyUserId = userinfo.loginId;
      this.motor.rate = 9600;
      this.motor.parity = 0;
      this.motor.dataBits = 8;
      this.motor.stopBits = 1;
      this.motor.isUse = true;
      this.editVisible = true;
      this.selectedOptions = [];
      this.headTitle = '新增设备信息';
    },
    handleChange: function handleChange() {
      var loc = '';

      for (var i = 0; i < this.selectedOptions.length; i++) {
        loc += CodeToText[this.selectedOptions[i]];
      }
    },
    handlePageChange: function handlePageChange(val) {
      this.$set(this.query, 'PageIndex', val);
      this.getData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    delAllSelection: function delAllSelection() {
      var _this5 = this;

      var length = this.multipleSelection.length;
      var str = '';
      var strValue = '';
      this.delList = this.delList.concat(this.multipleSelection);

      for (var i = 0; i < length; i++) {
        str += this.multipleSelection[i].name + ' ';
        strValue += this.multipleSelection[i].id + ',';
      }

      if (strValue.length == 0) {
        this.$notify.warning('请选择删除的行！');
        return;
      }

      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning'
      }).then(function () {
        _this5.$zybhttp.get('Motor/MotorDel', {
          params: {
            ids: strValue
          }
        }).then(function (res) {
          if (res.data.status == 0) {
            _this5.$notify.success("\u5220\u9664\u4E86".concat(str));

            _this5.getData();
          } else {
            _this5.$notify.error(res.data.msg);
          }
        }).catch(function (err) {
          return _this5.$notify.error('网络异常！删除失败');
        });

        _this5.multipleSelection = [];
      }).catch(function () {});
    },
    paramSetFun: function () {
      var _paramSetFun = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var length, data, res, pdata;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                length = this.multipleSelection.length;
                data = {};

                if (!(length == 0)) {
                  _context2.next = 5;
                  break;
                }

                this.$notify.warning('请选择设置参数的行！');
                return _context2.abrupt("return");

              case 5:
                if (!(length > 1)) {
                  _context2.next = 8;
                  break;
                }

                this.$notify.warning('只能选择一行！');
                return _context2.abrupt("return");

              case 8:
                data = this.multipleSelection[0];

                if (!(data.isUse != '1')) {
                  _context2.next = 12;
                  break;
                }

                this.$notify.warning('只有启用的才能设置参数！');
                return _context2.abrupt("return");

              case 12:
                _context2.next = 14;
                return MotorParaSet(data.id);

              case 14:
                res = _context2.sent;

                if (!(res.status != 0)) {
                  _context2.next = 20;
                  break;
                }

                this.$notify.warning(res.msg);
                return _context2.abrupt("return");

              case 20:
                this.paramVisible = true;
                pdata = res.data;
                this.paramSet = pdata;

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function paramSetFun() {
        return _paramSetFun.apply(this, arguments);
      }

      return paramSetFun;
    }(),
    indexMethod: function indexMethod(index) {
      return index + 1;
    },
    changeUse: function changeUse(row) {
      var _this6 = this;

      row.isUse = row.isUseFt ? '1' : '0';
      var motorType = row.motorType;

      if (motorType == '2' && this.volidArr.indexOf(row.id + '') > -1) {
        this.$notify.warning('该给料机在秤组中已启用，不允许停用！');
        this.getData();
        return;
      }

      this.$zybhttp.post('Motor/MotorUpdate', row).then(function (res) {
        if (res.data.status == 0) {
          _this6.$notify.success(res.data.msg);

          _this6.getData();
        } else {
          console.log(res.data.msg);

          _this6.$notify.error(res.data.msg);
        }
      }).catch(function (err) {
        return _this6.$notify.error('网络异常！修改失败');
      });
    }
  }
};